/**
 * 状态类：status { success、error、warn }
 * 弹窗类：dialog { toast、alert、confirm }
 * 表单类：from { placeholder、label }
 * 表格类：table { }
 *
 * 接口请求类：request
 * 接口响应类：responce
 *
 * 页面模块类：
 *
 */

// 使用 {{$t('purchase.periods')}}  //第*期

// 状态
const state = {
  preheatIng: "Preheat",
  purchaseIng: "subscribing",
  process: "In Process",
  over: "Ended",
  finish: "Completed",
  noData: "No data",
};

//抢购区和个人抢购记录页上方的subheader
const subheader = {
  pricePromise: "Price protection, no break",
  vipPrice: "Rebates for VIP",
  protection: "Price protection with fiat as standard",
  pricePromiseVal: "[*]-day price protection, no break",
  rewards: "[*]% rewards, Price protected ",
  vipDis: "Discount for VIP",
  zlz: "In Process",
};

// 抢购区
const purchase = {
  periods: "[*]Project",
  timesSheaves: "[*] Round",
  supportPic: "[*]-Day Break Insurance",
  earnings: "[*]% Earnings Guaranteed",
  vipDiscount: "Enjoy VIP Discount",
  limit: "Subscription quota",
  timeLimit: "Time-Limited Price",
  schedule: "Progress",
  finishHalf: "[*] Completed%",
  subscriptionNum: "Purchase amount",
  vipText: "(VIP[*]) enjoy ([**]） discount on buying ([****] [*****])",
  supportType:
    "Break Insurance: Within the insurance period, Biking will make orders in the secondary market at the lowest insurance price. You can choose whether to sell or not within the period. The relevant orders will be cancelled after the insurance period.",
  beAbouttoAlipay: "Start Soon",
  atOnceAlipay: "Purchase Now",
  atOnceAlipayNew: "Promote Now",
  atOnceAlipayed: "You subscribed,come next round", //"Only once subscription, please come again next round.",
  atOnceAlipayedOver: "You have made a purchase and there is no more chance.",
  atOnceAlipayedNew: "Please wait for next round.",
  atOnceAlipayedNewOver: "You have participated and there is no more chance.",
  website: "Website",
  whitePaper: "Whitepaper",
  foreshow: "Subscription Note",
  startToUp: "Start",
  startToUpNew: "Start",
  distanceStartToUp: "Begins in",
  num: "([*]) subscribers have purchased ([**] BAT).",
  bannerText: "[*] has purchased [**]",
  bannerTextNew: "[*] has contributed [**]",
  nextProject:
    "Your purchase has reached your individual limit. Please look forward to the next project.",
  timesText:
    "This round has finished and the next round is scheduled at [***]:[****]:[*****] on [*] [**].",
  times: "[*] Days [**] Hours [***] Min [****] Sec",
  viewDetail: "View details",
  completePawd: "Complete trade password setting",
  sureCoins:
    "Ensure the account position is more than [*] [**] (minimum subscription Turnover)",
  sureBalance: "Guarantee that [*] balances are more than [**]",
  set: "To set",
  available: "Available",
  holding: "Holding",
  startSoon: "Start soon",
  startSoonNew: "Start Soon",
  projectSupp: "Project supply",
  projectSuppNew: "Ceiling",
  successBuy: "Successful buying",
  successBuyNew: "Successful buying",
  projectLimit: "Begins in",
  subscription: "Successful subscription",
  subscriptionNew: "Succeeded",
  projectGoal: "Raising goal of this project",
  projectGoalNew: "Raising goal of this project",
  goalFunds: "The funds raised reached the goal",
  goalFundsNew: "The funds raised reached the goal",
};

//抢购条件

const purchaseCondition = {
  q: ", and ",
  h: ", or ",
  cztj: "Guarantee that the deposit amount",
  wqyh: "Only for users never participate in related events",
  vipdj: "Only for VIP[*] or above VIP users",
  condition: "Purchase Tips",
  conditionNew: "Conditions",
  nameverify1: "Complete KYC verification of Mainland China",
  nameverify2: "Complete KYC verification except for Mainland China",
  nameverify3: "Complete BiKing  KYC verification",
  login: "Log in",
  maxBuyin: "Maximum purchase",
  verify: "To identify",
  affirm: "Ensure the account position is more than [*]",
  myPosition: "My Holding",
  AmountOfAscension: "Purchase Amount",
  AmountOfAscensionNew: "Purchase Amount",
  AmountOfAscensionText:
    "If you holding more [*] of daily average position in the latest week before round 1 subscription，you will have more subscription quota.",
  AmountOfAscensionTime:
    "My holding [*] of daily average position in the latest week",
  discount: "Purchase Discount",
  vip_discount: "Participate Discount",
  discountText:
    "The higher your VIP level is, the lower your purchase price will be.",
  upgrade: "Level Up",
  vipUpgrade: "My VIP",
  zled: "Quota",
  wdzl: "My Promoting",
  zlxm: "Project",
  mlzl: "Amount of Each Round",
  zlmx: "Promoting Details",
  ccff: "First Issue",
  qgmx: "Purchase Details",

  fjtj: "Additional conditions",
  guoji: "Nationality",
  noJoin: " not support",
  wancheng: "Finish",
  pinggu: '"Digital Currency Investment Risk Assessment"',
  cyhd: "Participate",
};

// 历史项目
const historyProject = {
  rushLimit: "Subscription quota",
  averagePic: "Average Price",
  averageNum: "Subscribers",
};

// 支付
const alipay = {
  alipaynum: "Purchase amount",
  alipaynumNew: "Amount",
  ShouldPay: "Payable",
  VipDiscounts: "VIP Discount",
  VipWin: "Win Member discount",
  willOpen: "Coming Soon",
  actualPayment: "Actual Payment",
  actualPaymentNew: "This Round",
  importPassword: "Please enter trade password",
  forGetPassword: "Forgot trade password?",
  promptlyAlipay: "Pay Now",
  purchaseSuccess: "Congratulation",
  purchaseSuccessNew: "Congratulation",
  purchaseError: "Sorry. Your purchase failed. Please refresh and try again.",
};
// 项目详情
const projectDetails = {
  text: "Make sure your holding exceeds [*] [**]",
  timelimitPic: "Time-Limited Price",
  subscriptionLimit: "Total Supply",
  subscriptionLimitNew: "Amount",
  preheat: "Preheat",
  supportAbort: "Guarantee Deadline",
  unlockAbort: "Issue Time",
  projectIntroduction: "Project Introduction",
  projectRole: "Purchase Rules",
  rule: "Subscription Rules",
  ruleNew: "Rules",
};
// 抢购结束
const purchaseOver = {
  haveSubscribed: "Purchased",
  schedule: "Progress",
  Stime: "Start Time",
  StimeNew: "Start Time",
  Etime: "Close Time",
  EtimeNew: "End Time",
  successText:
    "The total supply of this project is [*] BAT and the actual purchase has reached the goal. Fundraising has succeeded!",
  success: "Succeeded",
};
// 我的抢购
const myPurchase = {
  endUnlock: "Unlock when the last round ends",
  endUnlock2: "To issue after the end of last round",
  LText: "Daily unlocking amount within insurance period",
  WText: "Daily unlocking amount beyond insurance period",
  unlockend: "Unlocked",
  record: "Subscription Details",
  myPurchaseName: "My Participation",
};

//mHeader
const mHeader = {
  sy: "Home",
  ksjy: "Basic",
  zyjy: "Pro",
  c2c: "C2C trading",
  otc: "OTC trading",
  zczx: "Assets",
  xwgg: "News",
  xwgg1: "Announcements",
  lc: "BiKing Earn",
  gxlc: "Wealth",
  dxjh: "FansUp!",
  fbjy: "Buy Crypto",
  dl: "Login",
  zc: "Sign up",
  jtzw: "简体中文",
  ftzw: "繁体中文",
  english: "English",
  kr: "한국어",
  qgms: "Buy",
  xsjy: "Limited",

  zczgz: "Total Asset Valuation",
  yhzx: "Account",
  wdgl: "Order Management",
  tc: "Log out",
  dltq: "low-circulation zone",

  sdgm: "Convert",
  zjhz: "资金划转",

  // app down
  appdown: "APP Download",
  appdown1: "Download",
  biking: "BiKing APP",
  gfqb: "Official wallet",
  xzbyapp: "BiKing App",
  xzbyapp2: "BiKing App",
  smewm: "Scan QR Code",
  xzhyqb: "HyperPay Wallet",
  xzhyqb2: " HyperPay Wallet",
  bbjy: "Spot",
  hyjy: "Swap",
  eftjy: "ETF Trading",
  byb: "Finance",
  newPos: "HBT Staking",
  HyperPay: "HyperPay",
  hqlc: "Pos Mining",
  newlc: "Finance",
  dd: "Order",
  zichan: "Balances",
  zhyaq: "Account&Security",
  xxzx: "消息中心",
  sfyz: "ID Verification",
  wdvip: "My VIP",
  apigl: "API",
  hdzx: "Activity",
  wdhb: "My red packets",
  flzx: "Center",
  bitloan: "BitLoan",
  hyxy: "Academy",
  ggjy: "Leverage trading",
  flhd: "Benefits",
  bitWin: "BitWin",
};

const res = {
  //抢购错误提示
  seckill_project_000: "System error",
  seckill_project_001: "No available projects",
  seckill_project_002: "The project information doesn't exist.",
  // 用户信息错误提示
  seckill_userInfo_001: "The user doesn't exist.",
  //i18n错误提示
  i18n_no_table_001: "The system is busy.",
  //抢购记录
  seckill_record_1: "Payment Failed",

  //7日持仓规则
  seckill_7days_1: "No holding rules of this project is found.",
  //钱包相关
  seckill_wallet_1: "The system is busy.",
  seckill_wallet_2: "Insufficient balances in your wallet",
  seckill_wallet_3: "Payment Failed",

  //项目统计
  seckill_record_count_1: "Data error",
  seckill_record_count_2: "Payment Failed",
  seckill_record_count_3: "Payment Failed",
  //项目轮次
  seckill_rounds_1: "The system is busy.",
  seckill_rounds_2: "In this project, no session is under progress",
  seckill_rounds_3: "In this project, no session information is found.",
  seckill_rounds_4: "The system is busy.",
  seckill_rounds_5:
    "In this project, no session information you want is found.",
  //项目信息
  seckill_pro_1: "No project information is found.",
  seckill_pro_2: "Your subscription amount is less than the min limit.",
  seckill_pro_4: "The system is busy.",

  seckill_pro_5: "The project is coming soon.",
  //支付
  seckill_pay_1: "The system is busy.",
  seckill_pay_2: "The system is busy.",
  seckill_pay_3: "No project information is found.",
  seckill_pay_4: "Your subscription amount is less than the min limit.",
  seckill_pay_5: "Your buying amount exceeds the remaining amount.",

  seckill_pay_6: "No buying amount is available.",

  seckill_pay_7: "Your buying amount exceeds the max limit.",
  seckill_pay_8: "The system is busy.",
  seckill_pay_9: "Payment password incorrect",

  seckill_pay_10: "Your payment failed and please buy again",
  seckill_pay_11: "Your payment failed and please buy again",

  seckill_pay_12: "Error in user information",
  seckill_pay_13: "Payment Failed",
  seckill_pay_14: "Payment password incorrect",
  seckill_pay_15: "Payment Failed",
  seckill_pay_16: "Sold out",
  seckill_pay_17:
    "Sorry, there are too many participants in the queue to purchase. Please retry.",
  seckill_pay_18: "Sold",
  seckill_pay_19: "Sold out",
  seckill_pay_20: "Please login",
  seckill_pay_21: "Please complete user identity verification.",
  seckill_pay_22:
    "This project is only available to Chinese mainland KYC users",
  seckill_pay_23:
    "This project is only available to Chinese non-mainland KYC users",
  seckill_pay_24: "No more tries to enter trade password. Please retry later",
  seckill_hold_1:
    "Your holding of [*] hasn't met the requirement. Please buy more before participate.",
  // 问卷调查
  seckill_survey_submited: "You have submitted this questionnaire",
  seckill_survey_error: "Questionnaire information processing error",
  seckill_survey_info: "No questionnaire information queried under the project",
};

const addContent = {
  qgsj: "Purchase time",
  qgsjNew: "Time",
  gz: "rules",
  zdjg: "min price",
  sq: "show less",
  qgms: "Buy",
  rgxm: "Participation Project",
  bled: "Supply of this round",
  dqjd: "Progress",
  yjs: "Unlocked",
  yff: "Issued",
  qbcc: "Guarantee the holding",
  cg: "Exceeds",
  jxmks: "Begins in",
  ycgrg: "Successful subscription",
  cgrg: "Successful buying",
  xmed: "Project quota",
  cxmck: "Raising goal of this project",
  ckmb: "The funds raised reached the goal",
  ck: "Raise",
  ckxq: "View details",
  kqed: "Available",
  zhcc: "Holding",
  jjks: "Start soon",
  mmsz: "Complete trade password setting",
  qsz: "To set",
  qbye: "Make sure your [*] balance is more than [**]",
  zjcz: "Ensure the account position is more than [*] [**] (minimum subscription Turnover)",
  jgdb: "Price protection, no break",
  jgyh: "Rebates for VIP",
  bwbj: "Price protection with fiat as standard",
  bj: "[*]-day price protection, no break",
  sybj: "[*]% rewards, Price protected ",
  zk: "Discount for VIP",
  r: "Participants",
  lsxm: "History Projects",
  bpf: " Community Power Comes With Plenty Benefits",
  syybz: "Low Threshold, Access For All",
  hg: "Become VIP, More Benefits",
  zgkx: "enjoy [*] [**] Discount",
  vip_zgkx:
    "Higher VIP level can enjoy higher discount. VIP6 have [*][**] discount",
  vip_zgkxNew:
    "Higher VIP level can enjoy higher discount. VIP6 have [*][**] discount",
  blsysj: "Ends in",
  blqbqw: "Sold out",
  xyl: "Next",
  zskq: "Start On Time",
  bljshs: "Ends in",
  zqyc: "You can only purchase once in each round. Please wait for the next.",
  zxkf: "Purchase now No right to participate , contact customer service",
  zqycNew: "Only once for each round. Please wait for the next!",
  wed: "The amount available is 0. Please wait for the next session.",
  wedNew: "No quota available. Please stay tuned for next project.",
  zsqg: "The min limit is [*] [**]. Please increase your balances.",
  srmm: "Please enter your trade password",
  smrz: "Please complete user identity verification.",
  qszjymm: "Please set the trading password first",
  wenjuandiaocha:
    "You need to finish the questionnaire before you can participate in this promotion.",
  scqgms: "Communities Assemble",
  hxyh: "Participate in Community Power, Get Different Benefits",
  zsqged: "The min limit is  [*] [**]",
  zsqgedNew: "Minimum limit[*] [**]",
  wmtj: "Your [**] balances are not enough. Please buy more before participate",
  qjchqg: "Please increase your balances.",
  qjchqgNew: "Please increase balance before participate",
  rgjg: "Subscription price",
  qqg: "Discount",
  wdqgjl: "My Records",
  ckxmxq: "project details",
  t: "day",
  yr: "[*]month[**]day",
  yrz: "Round  [*]  Preheating",
  qgz: "Round  [*]  Subscribing",
  djlyjs: "Round  [*]  Ended",
  dj: "VIP Level",
  xszk: "Discount price",
  jgzked: "Discount quota",
  zked: "discount quota",
  edw: "Pay extra amount at normal price",
  qbcczd:
    "Ensure the account position is more than 1000 COINS (minimum subscription Turnover)",
  qrrjcc: "Daily average position in the latest week",
  jlblks: "Distance Start",
  jlbljs: "Distance End",
  zgkqed: "Maximum subscription quota",
  zgkzf: "Maximum payable",
  cggmsl:
    "The Turnover of subscription you fill in exceeds your subscription limit.",
  bzzfzxgm:
    "Your current position is insufficient to pay the minimum subscription Turnover",
  bqzdqg: "The min. purchase limit of this promotion is [*] [**]",
  zlzcLower:
    "The minimum limit is [*] and the maximum is [**]. Rewards will be issued to your account within 5 working days after the event.",
  zgqged: "and the max. limit is [*] [**]",
  yzbz: "Time-limited discount only for BiKing fans",
  xszkj: "Discount",
  zlbxsq: "Time-limited Sale of Major Coins",
  wks: "Start Soon",
  jxz: "Underway",
  qgsl: "Purchase amount",
  wcydxm: "My Participation",
  bjq: "Buyback",
  hgq: "Period",
  qzk: "Discount",
  qxzl: "Join FansUp! Win Tokens",
  ds: "Purchase Ceiling",
  dhbl: "Exchange Rate",
  jicj: "Basic Price",
  jiagzd: "The final price will be set 3 hours prior to the purchase.",
  zdyh: "Max Discount",
  hdjshy:'The time end of activity',
};

const hyy = {
  bkt: "No",
  wqdkt: "Confirm",

  kt12: " 1. Before you participate, be sure to thoroughly understand the basic knowledge and related risks of digital currency contract transactions and the business rules related to participating in the derivatives transactions.",
  kt13: "  2. The risks mentioned above are only enumerative, and we fail to provide a detailed list of all risk factors related to digital asset derivatives trading. Investors should also seriously consider and accept other possible risks before investing in digital asset derivatives trading.",
  kt14: "3. We sincerely hope and advise investors to make a prudent decision on whether to participate in this contract transaction and rationally allocate their digital assets based on their own actual conditions such as risk tolerance.",

  kt0: "Dear user:",
  kt1: "You have not yet opened the contract account and granted contract trading permission, please read the following terms carefully before deciding whether to open:",
  kt2: "1. When you trade in the contract market, if the market price trend is against you and cause your position margin insufficient, BiKing perpetual contract will forced-liquidate your position according to the system agreement and disclose the details.",
  kt3: "2. You must read carefully and comply with the business rules of the BiKing perpetual contract, understand the mechanism and operating principle of the contract, and understand all risks of the market.",
  kt4: "4. BiKing perpetual contract is accessing to contract trading system. The gain and loss of the user's position changes with the fluctuation of contract market. When there’s big losses in the position, it will wipe out in the contract trading system. Users are requested to make their own timely trading behaviors according to the contract market, and they are responsible for their own gains and losses. Thus, BiKing does not assume any presumption or established guarantee responsibility.",
  kt5: "5. Under certain extreme market conditions, you may find it difficult or impossible to liquidate a position. This can occure, for example, when your profit ranks first in the effective leverage PnL across the contract market, and the opponent's position is insufficient for the insurance fund to cover its loss.",
  kt6: "6. Digital asset derivative transactions may face policy regulatory risks in a certain scope of Law. Before trading, you need to make a careful judgment on the premise of understanding the policy regulatory background of the transaction region. Due to changes in relevant national and regional laws, regulations, policies, amendments to contract exchange trading rules, and the introduction of emergency measures, BiKing will disclose the statement in advance. Your pending contracts may not continue to be held, but margin and profit balances will still be settled.",
  kt7: "7. The losses caused by part or whole failure to conclude transaction when the part or whole failure is due to reasons uncontrolled by BiKing, for example, earthquake, flood, fires, and other force majere, or malfunctions of computer or communication system are undertaken at your own.",
  kt8: "8. 'Hedging' transactions, like speculative transaction, are also subject to risks arising from price fluctuations.",

  kta9: "9. If you do not have real-name authentication or are not bound to Google verification, or lend your account to someone else, it may reduce the safety of your contract margin.",

  kta10:
    "3. Under certain extreme market conditions, you may find it difficult or impossible to liquidate a position. This can occure, for example, when your profit ranks first in the effective leverage PnL across the contract market, and the opponent's position is insufficient for the insurance fund to cover its loss.",

  kt9: "I have read the Risk Warning carefully and agree to take all the risks",
  kt10: "Open contract account and grant contract trading permission",
  zjhz: "Transfer",
  ljhz: "Transfer now",
  qx: "Cancel",
  khz: "Can be transfered",
  qxz: "Please choose",
  bz: "Currency",
  c: "from",
  zz: "to",
  sl: "Amount",
  qb: "All",
  ktcg: "Succeeded",
  ktsb: "Failed",
  hzcg: "Succeeded",
  hzsb: "Failed",
  wyyd: "", //未勾选已经阅读提示文案
  tc: "Sign out",
  warning1: "Please choose the currency",
  warning2: "Please enter transfer-out account",
  warning3: "Please enter transfer-in account",
  warning4: "Please enter the quantity that is less than the availale quantity",
  warning5: "Keep up to 4 decimal places",
  gb: "Close",
  openSuccess: "You confirmed Contract Trading",
  openSuccessTip: "Please transfer assets",
  not_get_nm:
    "Sorry, non-neg chips activity has been released. non-neg chips can not be obtained in this transfer",
};

const trading = {
  gflj: 'official link',
  gw: 'official website',
  qkllq: 'block explorer',
  scfxsj: 'first issue date',
  fxzl: 'total issuance',
  ltzl: 'total circulation',
  jy: 'Trade',
  sj: 'Market price',
  tbxx: 'Chart',
  bzgk: 'Overview',
  ddb: 'Order form',
  zxcj: 'Latest transaction',
  
  reload: "refresh",
  socketError: "Network error, please",
  noData: "No data",
  entrustorder: "Order Book",
  prices: "Price",
  quantity: "Amount",
  grandtotal: "Cumulative",
  transamount: "Total",
  time: "Time",
  available: "Available",
  limitorder: "Limit",
  plancommission: "Trigger order",
  currentcommission: "Entrust",
  historycommission: "Order History",
  completecommission: "Completed",
  funds: 'Funds',
  hidetrading: "Hide others",
  morecurrentcommission: "More Orders",
  morehistorycommission: "More histories",
  moredocommission: "More dealed",
  realtimetrans: "Real-time",
  myassets: "My assets",
  detail: "Details",
  buyin: "BUY",
  sellout: "SELL",
  login: "Login",
  transfer: "Transfer",
  recharge: "Deposit",
  withdrawal: "Buy Crypto",
  quickpurchase: "OTC quick purchase",
  default: "Default",
  ordertime: "Order Time",
  tradingpair: "Pair",
  direction: "Side",
  types: "Type",
  commissionprice: "Order Price",
  commissionnumber: "Order Amount",
  dealprice: "Deal Average Price",
  dealnumber: "Deal Amount",
  triggerprice: "Trigger Price",
  cancelall: "Cancel all",
  averageprice: "Ave price",
  totalsum: "Sum",
  fixedprice: "Limit price",
  marketprice: "Market price",
  codeExpired: "QR Code expired",
  clickRefresh: "Click to refresh",
  QRsuccessfully: "Successfully",
  loginInApp: "Please confirm your login in the APP",
  backtoQR: "Back to QR Code login",
  loginSuccess: "Login successfully, welcome to BiKing.",
  loadingText: "Loading...",
  searchPlaceholder: "search",
  all: "All",
  currency: "Pair",
  price: "Latest Price",
  market: "Increase",
  increase: "change",
  highestPrice: "Highest",
  minimumPrice: "Lowest",
  turnover: " Vol",
  jydlb: "Trading Pair",
  bzjs: "Introduction",
  currencyTransaction: "Spot",
  leveragedTransaction: "Leverage",
  warning:
    "Risk Warning: Bitcoin Cash fork has great uncertainty. Trading or investing in fork futures tokens is highly risky. Any chain lacking the support of miners may be unable to survive, which results in a value zero-out of tokens held. BiKing does not make any promise for the value of any forked futures tokens!",
  zb: "Indicatrix",
  UpAnddown: "Change",
  amplitude: "amplitude",
  0: "TL",
  1: "1M",
  5: "5M",
  15: "15M",
  30: "30M",
  60: "1H",
  240: "4H",
  3600: "1Day",
  10800: "1W",
  dates: "Cycle：",
  password: "Trade password",
  errorPassword: "Please enter correct password",
  worningPassword: "Please enter the trade password",
  cancel: "Cancel",
  sure: "Confirm",
  canBuy: "Total Asset Valuation",
  canCell: "Total Asset Valuation",
  withdraw: "Withdraw",
  otc: "OTC，Fast Deposit and Withdrawal Fiat",
  enterPrice: "Please enter the price",
  sellingPrice: "Price",
  purchasePrice: "Price",
  salesTurnover: "sell amount",
  buyingTurnover: "Buy amount",
  buyingVolume: "Amount",
  salesVolume: "Amount",
  volume: "Total",
  Turnover: "Turnover",
  serviceCharge: "Fee",
  vip: "Join VIP  to enjoy fee discount",
  or: "or",
  register: "Sign up",
  totalPrice: "Trading amount cannot be greater than",
  amountTip: "Please enter the correct amount",
  amountTipError: "Quantity cannot be greater than",
  limitTrading: "Limit Order",
  priceReminder: "price alert",
  SMSReminder: "SMS Alerts",
  loginAccount: "Login account",
  phone: "phone",
  phoneNum: "Please enter your phone number",
  phoneTips: "Please enter correct phone number",
  email: "email",
  emailNum: "Please enter email address",
  emailTips: "Please enter correct email address",
  aears: "Please select area code",
  passwordError: "Please enter correct password",
  passwordTips: "Please enter password",
  forgetPassword: "Forgot password",
  noAccount: "Not on BiKing yet",
  goRegister: "Register Now",
  appsys: "Scan in APP to login",
  xzapp: "Download the latest version of APP",
  mmdl: "Enter password",
  smdl: "Scan code",
  google: "Google authenticator",
  nybd: "You have linked a ",
  zqyzm: "Please enter correct verification code",
  fsyzm: "Send Code",
  flv: "Fee Rate",
  jz: "Net worth",
  jzdesc1:
    "Long net worth = net worth at the last adjustment point * [1 + 3 * (the latest executed price of the spot-the price at the last adjustment point of the spot) / price at the last adjustment point of the spot * 100%];",
  jzdesc2:
    "Short net worth = net worth at the last adjustment point * [1 - 3 * (the latest executed price of the spot-the price at the last adjustment point of the spot) / price at the last adjustment point of the spot * 100%];",
  sbd: "3XL",
  sbs: "3XS",
  flvjs:
    "ETF fund rate is the daily management fee charged in proportion for leverage by the platform to pay the funding rate generated by the fund portfolio. The management fee will be manifested on the dynamics of net worth. It is only charged at 00:00 (Singapore time). No fee will be charged if you do not hold Leveraged ETF product at the time point.",
  mzsm: "Disclaimer",
  ido: "I have read and agree",
  exemption1: "Dear user, hello!",
  exemption2:
    'Thank you for logging in and using the leverage ETF products and related services (hereinafter referred to as "ETF products") provided by BiKing.ai. Please read the ETF product description and the following risk warnings carefully. If you choose to continue using ETF products after it, it is deemed that you have fully acknowledged and understood the risks of ETF products, and have the capacity to bear the losses that may be caused by using ETF products. Also, you agree with the entire contents of this disclaimer.Please click to read the ETF product description: ',
  exemption3: "《Leverage ETF Product FAQ》",
  exemption4: "Risk warning：",
  exemption5:
    "1. The price you buy / sell should not deviate significantly from the unit's net worth, otherwise you will suffer corresponding losses.",
  exemption6:
    "2. If the direction is wrong, there will be a risk that the price will approach zero in extreme conditions.",
  exemption7:
    "BiKing hereby solemnly reminds you that any losses or liabilities caused by the above risks will be borne by you and BiKing will not bear any responsibility for this. This disclaimer, together with other agreements, statements, rules, etc., constitute all the agreements reached on the services and products of the BiKing between you and BiKing.",
  bzjs1:
    '1、"3L" means the price of underlying trading pair increase 1%, so that the product\'s net worth increase 3%',
  bzjs2:
    '2、"3S" means the price of underlying trading pair decrease 1%, so that the product\'s net worth increase 3%',
  bzjs3:
    "3、The net worth is normally adjusted at 0 o'clock every day, and is adjusted intraday under extreme market.",
  bzjs4:
    "4、Each times leverage will charge the corresponding management fee on a daily basis",
  bzjs5:
    "5、Please pay attention to check the net worth before trading. Under extreme market conditions, the price will approach zero, and will deviate far from the net worth. Investors should pay attention to controlling risks",
  gdjk: "Please refer to News for more details",
  firstTrading: "Please set trade password before your first trading",
  status: "Status",
  status1: "To be matched",
  status2: "Uncompleted",
  status3: "Canceled",
  status4: "Partially completed",
  status5: "Completed",
  status6: "Invalid",
  allCancel:
    "Batch cancel all orders",
  canceld: "Cancelled",
  cancelsuccess:
    "All orders have been cancelled successfully, [*] orders have been cancelled",
  VIP1: "Your VIP level",
  VIP2: "Lower transaction fee cost, but better transaction experience",
  VIP3: "Taker：",
  VIP4: "Maker：",
  buyAmount: "Buy quantity cannot be greater than",
  sellAmount: "Sell quantity cannot be greater than",
  buyAmountMin: "Your available balance is insufficient",
  sellAmountMin: "Your available balance is insufficient",
};
const common = {
  wan: "M",
  qian: "K",
  yi: "B",
};
const transferDialog = {
  划转: "Transfer",
  资金互转: "Transfer",
  币币账户: "Spot A/C",
  买币账户: "Buy A/C",
  已冻结: "Frozen",
  合约账户: "Swap A/C",
  未开通: "Not opened",
  杠杆账户: "Leverage Account",
  币贷宝账户: "BitLoan A/C",
  从: "From",
  转至: "Transfer to",
  币种: "Coin",
  数量: "Amount",
  全部: "All",
  用户未归还借贷的情况下:
    "When the user does not repay the loan, funds with a risk rate greater than 200% can be transferred out",
  可划转: "Available",
  一阶: "1. First-level",
  累计净划入: "cumulative net transfer reaching",
  可获得: "can get",
  泥码: "non-neg chip",
  二阶: "2. second-level",
  您尚未完成实名认证: "You have not completed real-name verification",
  余额: "Balance",
  立即划转: "Transfer now",
  资产划转: "Transfer",
  用于维持现有仓位的保证金: "Margin for maintaining holding positions",
  归还数量: "Repayment quantity",
  您的币贷宝账户尚未开通:
    "Your BitLoan account has not been opened yet, please open it first",
  请输入正确的数量: "Please enter the correct amount",
  划转金额不能为: "Transfer amount cannot be 0",
  账户可用余额不足: "Insufficient account available balance",
  划转失败: "Failed",
  划转成功: "Succeeded",
  本次划转未能获得泥码:
    "Sorry, non-neg chips activity has been released. Non-neg chips can not be obtained in this transfer",
  您只需再向合约账户划转:
    "Transfer [*] USDT to the contract account to get [**] USDT non-neg chips",
  您向合约账户:
    "Cumulative net transfer to<br/> contract account above [*]USDT, get",
  请输入划转数量: "Please enter transfer quantity",
};

export {
  state,
  purchase,
  subheader,
  purchaseCondition,
  historyProject,
  alipay,
  projectDetails,
  purchaseOver,
  myPurchase,
  mHeader,
  res,
  addContent,
  hyy,
  trading,
  common,
  transferDialog,
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js